import React, { memo } from 'react';
import { Position } from 'reactflow';
import { Tooltip } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import EnhancedHandle from './EnhancedHandle';

const CompleteNode = ({ data, isConnectable, selected }) => {
    // Get description if available
    const description = data.config?.description || 'Workflow completes successfully';

    // Show execution count badge if available
    const ExecutionCountBadge = () => {
        if (data.executionCount === undefined) return null;

        return (
            <div style={{
                position: 'absolute',
                top: -8,
                right: -8,
                background: '#1890ff',
                color: 'white',
                borderRadius: '50%',
                width: 22,
                height: 22,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 'bold',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                zIndex: 10
            }}>
                {data.executionCount}
            </div>
        );
    };

    return (
        <Tooltip title={description}>
            <div
                style={{
                    width: 220,
                    height: 80,
                    position: 'relative',
                    background: selected ? '#f6ffed' : 'white',
                    border: selected ? '1px solid #52c41a' : '1px solid #d9d9d9',
                    borderRadius: '8px 8px 30px 30px', // Rounded bottom corners
                    overflow: 'hidden',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                    fontFamily: 'Arial, sans-serif'
                }}
            >
                <ExecutionCountBadge />

                {/* Header */}
                <div style={{
                    background: '#52c41a',
                    color: 'white',
                    padding: '8px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    borderBottom: '1px solid #d9d9d9'
                }}>
                    <CheckCircleOutlined style={{ fontSize: 16, marginRight: 8 }} />
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {data.label || 'Complete'}
                    </div>
                </div>

                {/* Content */}
                <div style={{
                    padding: '10px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#52c41a',
                    fontWeight: 'bold',
                    fontSize: '13px'
                }}>
                    Workflow Completed
                </div>

                {/* Input handle - enhanced */}
                <EnhancedHandle
                    type="target"
                    position={Position.Top}
                    id="in"
                    style={{
                        top: -6
                    }}
                    color="#52c41a"
                    isConnectable={isConnectable}
                />
            </div>
        </Tooltip>
    );
};

export default memo(CompleteNode);
